export default {
  country_locale: 'pl-PL',
  wia_contact_links: {
    ID: 'https://www.indesit.pl/pomoc/formularz-kontaktowy'
  },
  wia_title: 'Zacznij od produktu:',
  wia_need_help: 'Czy potrzebujesz pomocy?',
  wia_model_name: 'Nazwa modelu to',
  wia_back: '< Zmień',
  wia_confirm: 'Wyślij',
  wia_issue_title: 'W czym tkwi problem?',
  wia_issue_concern: 'Czego dotyczy problem?',
  wia_issue_specific: 'Szczególny rodzaj problemu',
  wia_possible_solution: 'Możliwe rozwiązania',
  wia_solved_issue: 'Czy rozwiązałeś problem?',
  wia_closed: 'Zamknij',
  wia_feedback_ok: ' Tak',
  wia_find_another_solution: 'Znajdź inne rozwiązanie',
  wia_feedback_title: 'Cieszymy się, że problem został rozwiązany!',
  wia_feedback_text1: 'Odkryj nasze plany ochrony',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Odkryj nasze plany ochrony',
  wia_smile_down_popup_title: 'Czy nadal potrzebujesz pomocy?',
  wia_smile_down_popup_text1: 'Przejdź do drugiego kroku',
  wia_smile_down_popup_or_text: 'czy',
  wia_smile_down_popup_text2: 'Zarezerwuj naprawę',
  wia_need_more_help: 'Czy nadal potrzebujesz pomocy?',
  wia_optional_label: '(Opcjonalne)',
  wia_no_solution: 'Nie byliśmy w stanie znaleźć szybkiego rozwiązania, ale nie martw się, nadal możemy Ci pomóc. Kliknij tutaj, aby uzyskać dostęp do pomocy technicznej.',
  wia_all_solution: 'Wszystkie wyniki',
  wia_all_categories: 'Wszystkie kategorie',
  wia_seo_l1_issue: 'Wszystkie usterki według kategorii',
  wia_seo_wp_country_name: 'Polska',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: 'PL',
  wia_seo_id_country_name: 'PL',
  wia_seo_wp_meta_title: 'Rozwiązywanie problemów',
  wia_seo_bk_meta_title: '',
  wia_seo_hp_meta_title: 'Rozwiązywanie problemów',
  wia_seo_id_meta_title: 'Rozwiązywanie problemów',
  wia_seo_wp_meta_description: 'Wsparcie techniczne online pomoże Ci rozwiązać najczęstsze problemy z urządzeniami',
  wia_seo_bk_meta_description: '',
  wia_seo_hp_meta_description: 'Dzięki pomocy technicznej online możesz rozwiązać najczęstsze problemy z urządzeniami',
  wia_seo_id_meta_description: 'Rozwiąż problemy z urządzeniami dzięki internetowej pomocy technicznej',
  wia_seo_wp_meta_description_home: 'Rozwiąż problemy z urządzeniami dzięki internetowej pomocy technicznej Whirlpool PL',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: 'Wsparcie techniczne online Hotpoint PL pomoże Ci rozwiązać najczęstsze problemy z urządzeniami',
  wia_seo_id_meta_description_home: 'Dzięki pomocy technicznej online Indesit PL możesz rozwiązać najczęstsze problemy z urządzeniami'
}
